import type {CurrentProject} from 'common/report/model-resources/projects';
import type {DataGroupStore} from 'common/report/stores/data-groups';
import {isMetricLevelDataGroupsEnabled} from 'common/report/util/feature-sampling';

/** Checks the project has the relevant feature flags and some non-user data groups
 *
 * This can be removed after metric-level data groups is fully rolled out. It's in a separate file to avoid a circular dependency issue
 */
export function canShowMetricDataGroupSelect({
  currentProject,
  dataGroupStore,
}: {
  currentProject?: CurrentProject;
  dataGroupStore: DataGroupStore;
}) {
  const hasMetricLevelDataGroups = isMetricLevelDataGroupsEnabled(currentProject) && currentProject?.canUseDataGroups();
  return hasMetricLevelDataGroups && dataGroupStore.value && Object.values(dataGroupStore.value).length;
}
